import { render, staticRenderFns } from "./LabelLog.vue?vue&type=template&id=1595aad4&scoped=true&"
import script from "./LabelLog.vue?vue&type=script&lang=js&"
export * from "./LabelLog.vue?vue&type=script&lang=js&"
import style0 from "./LabelLog.vue?vue&type=style&index=0&id=1595aad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595aad4",
  null
  
)

export default component.exports